/* eslint-disable no-console */
import { addRoutesAndHooks } from './router';
import components from '@/components/components';
import services from './services';
import filters from '@/filters/filters';
// import directives from './v-directives';

const AppCore = {
  /**
   * Installs plugin on vue project.
   * @param {Object} Vue Vue Object
   */
  install(Vue, { router }) {
    if (!process.env.VUE_APP_HIDE_ENVS) console.log(process.env);
    if (!router) {
      throw new Error('Router object is required.');
    }
    console.log(`%cApp run in ${process.env.VUE_APP_ENV} environment`, 'color: Lightblue');
    addRoutesAndHooks(router);

    /* Register all components */
    console.log(`🛠%cComponent logging...%c`, 'color: green', 'font-weight: bold');
    Object.keys(components).forEach(key => {
      Vue.component(key, components[key]);
    });

    /* Register all services*/
    console.log(`🛠%cService logging...%c`, 'color: green', 'font-weight: bold');
    Object.keys(services).forEach(key => {
      Vue.prototype[key] = services[key];
    });

    /* Register all filters */
    console.log(`🛠%cFilters logging...%c`, 'color: green', 'font-weight: bold');
    Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));

    Vue.prototype.$console = {
      error(text) {
        if (process.env.VUE_APP_ENV === 'development') {
          console.error(`[LOG ${process.env.VUE_APP_ENV}]`, text);
        }
      },
      table(text) {
        if (process.env.VUE_APP_ENV === 'development') {
          console.log(`[LOG ${process.env.VUE_APP_ENV}]`);
          console.table(text);
        }
      },
      warn(text) {
        if (process.env.VUE_APP_ENV === 'development') {
          console.warn(`[LOG ${process.env.VUE_APP_ENV}]`, text);
        }
      },
      log(text) {
        if (process.env.VUE_APP_ENV === 'development') {
          console.log(`[LOG ${process.env.VUE_APP_ENV}]`, text);
        }
      }
    };
  }
};

export default AppCore;
